import { createAsyncThunk } from "@reduxjs/toolkit";
import { alertError } from "shared/api/alertError";
import { personalCabinetAPI } from "../api/index";

interface PostApplicationPwdData {
  distanceId: number | undefined;
}

export const postApplicationPwdCreateThunk = createAsyncThunk(
  "personalCabinet/postApplicationPwd",
  async (data: PostApplicationPwdData, { rejectWithValue }) => {
    try {
      const res = await personalCabinetAPI.postApplicationPwd(data);
      if (typeof res.data === 'string') {
        if (res.data.startsWith('http')) {
          window.open(res.data, "_blank");
        } else if (!isNaN(Number(res.data))) {
          window.location.reload();
        }
      } else if (typeof res.data === 'number') {
        window.location.reload();
      } else if (!res.data) {
        window.location.reload();
      }
      return res.data;
    } catch (error: any) {
      if (error.response.data.title) {
        alertError(error.response.data.title);
      }
      return rejectWithValue(error.response.data.title);
    }
  }
);
